export default [
  {
    name: 'account-type-create',
    path: '/account-types/create',
    component: () => import('@/views/account-types/AccountTypeManage')
  },
  {
    name: 'account-type-edit',
    path: '/account-types/:id/edit',
    component: () => import('@/views/account-types/AccountTypeManage')
  },
  {
    name: 'account-type-view',
    path: '/account-types/:id/view',
    component: () => import('@/views/account-types/AccountTypeManage')
  },
  {
    name: 'account-type-find',
    path: '/account-types/find',
    component: () => import('@/views/account-types/AccountTypeFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeAccountTypes.js